module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921133834_T.18298e25.jpg";